import { LessonProblem, StudentProblemResult } from '@yandex-int/k-common/typings';
import b from 'b_';
import { Text } from 'platform-components';
import React from 'react';

import { PROBLEM_DISPLAY_STATUS } from 'common.components/student-lesson-stat/typings';
import { getProblemDisplayStatus } from 'common.components/student-lesson-stat/utils';
import { isOpenAnswer } from 'store/problems/utils';

import { StatItem } from '../lesson-content__stat-item-wrapper';

export const ProblemStatus = (props: {
    problemLink: LessonProblem;
    studentProblemResult: StudentProblemResult | null;
}) => {
    const { problemLink, studentProblemResult } = props;

    if (isOpenAnswer(problemLink?.problem)) {
        const hasTime = Boolean(studentProblemResult?.time);
        const status = hasTime ? PROBLEM_DISPLAY_STATUS.SEEN : PROBLEM_DISPLAY_STATUS.NOT_SEEN;

        return (
            <StatItem>
                <Text id="studentLessonStat.cardStatus" values={{ status }} />
            </StatItem>
        );
    }

    const status = getProblemDisplayStatus(problemLink, studentProblemResult);

    return (
        <StatItem>
            <Text id="studentLessonStat.cardStatus" values={{ status }} />
            <span className={b('lesson-content', 'stat-detail-marker', { status })} />
        </StatItem>
    );
};
